import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { GiMagnifyingGlass } from 'react-icons/gi';
import { FaNewspaper, FaCamera, FaTv } from 'react-icons/fa';

const links = [
  {
    url: '/search',
    text: (
      <>
        <GiMagnifyingGlass className='mr-1' /> All
      </>
    ),
  },
  {
    url: '/news',
    text: (
      <>
        <FaNewspaper className='mr-1' /> News
      </>
    ),
  },
  {
    url: '/images',
    text: (
      <>
        <FaCamera className='mr-1' /> Images
      </>
    ),
  },
  {
    url: '/videos',
    text: (
      <>
        <FaTv className='mr-1' /> Videos
      </>
    ),
  },
];

const Links = () => {
  const location = useLocation();

  return (
    <div className='flex sm:justify-around justify-between items-center mt-4 w-full'>
      {links.map(({ url, text }, index) => (
        <NavLink
          to={url}
          key={index}
          className={`flex flex-row pb-2 leading-4 mx-3 mb-0 mt-2 ${
            location.pathname === url
              ? 'text-blue-700 border-b-2 dark:text-blue-300 border-blue-700'
              : 'text-black dark:text-white '
          }`}
        >
          {text}
        </NavLink>
      ))}
    </div>
  );
};
export default Links;
